export const DOCTOR_AVAILABILLITY_CREATE_REQUEST = 'DOCTOR_AVAILABILLITY_CREATE_REQUEST'
export const DOCTOR_AVAILABILLITY_CREATE_SUCCESS = 'DOCTOR_AVAILABILLITY_CREATE_SUCCESS'
export const DOCTOR_AVAILABILLITY_CREATE_FAIL = 'DOCTOR_AVAILABILLITY_CREATE_FAIL'
export const DOCTOR_AVAILABILLITY_CREATE_RESET = 'DOCTOR_AVAILABILLITY_CREATE_RESET'
export const DOCTOR_AVAILABILLITY_GET_ALL_REQUEST = 'DOCTOR_AVAILABILLITY_GET_ALL_REQUEST'
export const DOCTOR_AVAILABILLITY_GET_ALL_SUCCESS = 'DOCTOR_AVAILABILLITY_GET_ALL_SUCCESS'
export const DOCTOR_AVAILABILLITY_GET_ALL_FAIL = 'DOCTOR_AVAILABILLITY_GET_ALL_FAIL'
export const DOCTOR_AVAILABILLITY_GET_ALL_RESET = 'DOCTOR_AVAILABILLITY_GET_ALL_RESET'
